import { makeAppStyles } from "../../../../../../../uikit";

export const useStyles = makeAppStyles(theme => ({
  AddMeet: {
    color: theme.think12.colors.white.main,
  },
}));
